export default __webpack_public_path__ + "static/media/acceptConsent.8647531f.png";